import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import * as logoFile from './carlogo.js';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ExportExcelService {
  // static generateExcel() {
  //   throw new Error('Method not implemented.');
  // }

  constructor(private datePipe: DatePipe) { }

  generateExcel(): void {
    const title = 'Car Sell Report';
    const header = ['Year', 'Month', 'Make', 'Model', 'Quantity', '%age'];

    const data = [
      [2007, 1, 'Volkswagen ', 'Volkswagen Passat', 1267, 10],
      [2007, 1, 'Toyota ', 'Toyota Rav4', 819, 6.5],
      [2007, 1, 'Toyota ', 'Toyota Avensis', 787, 6.2],
      [2007, 1, 'Volkswagen ', 'Volkswagen Golf', 720, 5.7],
      [2007, 1, 'Toyota ', 'Toyota Corolla', 691, 5.4],
      [2007, 1, 'Peugeot ', 'Peugeot 307', 481, 3.8],
      [2008, 1, 'Toyota ', 'Toyota Prius', 217, 2.2],
      [2008, 1, 'Skoda ', 'Skoda Octavia', 216, 2.2],
      [2008, 1, 'Peugeot ', 'Peugeot 308', 135, 1.4],
      [2008, 2, 'Ford ', 'Ford Mondeo', 624, 5.9],
      [2008, 2, 'Volkswagen ', 'Volkswagen Passat', 551, 5.2],
      [2008, 2, 'Volkswagen ', 'Volkswagen Golf', 488, 4.6],
      [2008, 2, 'Volvo ', 'Volvo V70', 392, 3.7],
      [2008, 2, 'Toyota ', 'Toyota Auris', 342, 3.2],
      [2008, 2, 'Volkswagen ', 'Volkswagen Tiguan', 340, 3.2],
      [2008, 2, 'Toyota ', 'Toyota Avensis', 315, 3],
      [2008, 2, 'Nissan ', 'Nissan Qashqai', 272, 2.6],
      [2008, 2, 'Nissan ', 'Nissan X-Trail', 271, 2.6],
      [2008, 2, 'Mitsubishi ', 'Mitsubishi Outlander', 257, 2.4],
      [2008, 2, 'Toyota ', 'Toyota Rav4', 250, 2.4],
      [2008, 2, 'Ford ', 'Ford Focus', 235, 2.2],
      [2008, 2, 'Skoda ', 'Skoda Octavia', 225, 2.1],
      [2008, 2, 'Toyota ', 'Toyota Yaris', 222, 2.1],
      [2008, 2, 'Honda ', 'Honda CR-V', 219, 2.1],
      [2008, 2, 'Audi ', 'Audi A4', 200, 1.9],
      [2008, 2, 'BMW ', 'BMW 3-serie', 184, 1.7],
      [2008, 2, 'Toyota ', 'Toyota Prius', 165, 1.6],
      [2008, 2, 'Peugeot ', 'Peugeot 207', 144, 1.4]
    ];
  
    const ExcelJS = require('exceljs');
      // Create workbook and worksheet
      let workbook = new ExcelJS.Workbook();
      let worksheet = workbook.addWorksheet('Car Data');
      // Add Row and formatting
    const titleRow = worksheet.addRow([title]);
    titleRow.font = { name: 'Comic Sans MS', family: 4, size: 16, underline: 'double', bold: true };
    worksheet.addRow([]);
    const subTitleRow = worksheet.addRow(['Date : ' + this.datePipe.transform(new Date(), 'medium')]);


// Add Image
    const logo = workbook.addImage({
  base64: logoFile.logoBase64,
  extension: 'png',
});

    worksheet.addImage(logo, 'E1:F3');
    worksheet.mergeCells('A1:D2');


// Blank Row
    worksheet.addRow([]);

// Add Header Row
    const headerRow = worksheet.addRow(header);

// Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFFFFF00' },
    bgColor: { argb: 'FF0000FF' }
  };
  cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
});
// worksheet.addRows(data);


// Add Data and Conditional Formatting
    data.forEach(d => {
  const row = worksheet.addRow(d);
  const qty = row.getCell(5);
  let color = 'FF99FF99';
  if (+qty.value < 500) {
    color = 'FF9999';
  }

  qty.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: color }
  };
}

);

    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 30;
    worksheet.addRow([]);


// Footer Row
    const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
    footerRow.getCell(1).fill = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: 'FFCCFFE5' }
};
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

// Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

// Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
  const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  fs.saveAs(blob, 'CarData.xlsx');
});

  }

  exportExcel(excelData) {

    //Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers
    const data = excelData.data;
    const footer = excelData.footers;
    let FromDate = excelData.FromDates;
    let ToDate = excelData.UpToDates;

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Data');


    //Add Row and formatting
    worksheet.mergeCells('A1', 'E2');
    let titleRow = worksheet.getCell('C1');
     titleRow.value = title
    titleRow.font = {
      name: 'Calibri',
      size: 16,
      underline: 'single',
      bold: true,
      color: { argb: '0085A3' }
    }
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' }

    // Date
    //worksheet.mergeCells('F1:G4');
    // let d = new Date();
    // let date = d.getDate() + '-' + d.getMonth() + '-' + d.getFullYear();
    // let dateCell = worksheet.getCell('F1');
    // dateCell.value = date;
    // dateCell.font = {
    //   name: 'Calibri',
    //   size: 12,
    //   bold: true
    // }
    // dateCell.alignment = { vertical: 'middle', horizontal: 'center' }
    FromDate = new Date(FromDate).getDate() + '-' + ((new Date(FromDate).getMonth())+1) + '-' + new Date(FromDate).getFullYear()  + ' ' + new Date(FromDate).getHours() + ':' + new Date(FromDate).getMinutes() + ':' + new Date(FromDate).getSeconds();
    ToDate = new Date(ToDate).getDate() + '-' + ((new Date(ToDate).getMonth())+1) + '-' + new Date(ToDate).getFullYear()  + ' ' + new Date(ToDate).getHours() + ':' + new Date(ToDate).getMinutes() + ':' + new Date(ToDate).getSeconds();


    let FromCellText = worksheet.getCell('B4');
    FromCellText.value = "From Date :"
    FromCellText.font ={bold:true}
    let UptoCellText = worksheet.getCell('B5');
    UptoCellText.value = "To Date :"
    UptoCellText.font ={bold:true}
    let FromCellTextDate = worksheet.getCell('C4');
    FromCellTextDate.value = FromDate;
    //FromCellText.font ={bold:true}
    let UptoCellTextDate = worksheet.getCell('C5');
    UptoCellTextDate.value = ToDate;
    //UptoCellText.font ={bold:true}
    //Add Image
    // let myLogoImage = workbook.addImage({
    //   base64: logoFile.logoBase64,
    //   extension: 'png',
    // });
    // worksheet.mergeCells('A1:B4');
    // worksheet.addImage(myLogoImage, 'A1:A4');

    //Blank Row
    worksheet.addRow([]);
    worksheet.addRow([]); 
    //Adding Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DDD9C4' },
        bgColor: { argb: '' } 
               
      }
      cell.font = {
        bold: true,
        color: { argb: '000000' },
        size: 11
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' }

    // Adding Data with Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
      row.eachCell((cell, number) => {
        // cell.fill = {
        //   type: 'pattern',
        //   pattern: 'solid',
        //   fgColor: { argb: 'DDD9C4' },
        //   bgColor: { argb: '' } 
                 
        // }
        // cell.font = {
        //   bold: true,
        //   color: { argb: '000000' },
        //   size: 11
        // }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      })
      row.alignment = { vertical: 'middle', horizontal: 'center' }

      let sales = row.getCell(2);
      //let color = 'FF99FF99';
      sales.alignment = { vertical: 'middle', horizontal: 'left' }
      let cell3 = row.getCell(3);
      cell3.value = Number(cell3.value);
      let cell4 = row.getCell(4);
      cell4.value = Number(cell4.value);
      let cell5 = row.getCell(5);
      cell5.value = Number(cell5.value);
      // if (+sales.value < 200000) {
      //   color = 'FF9999'
      // }
      //let sales = row.getCell(5);
      // let color = 'FF99FF99';
      // if (+sales.value < 200000) {
      //   color = 'FF9999'
      // }

      // sales.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color }
      // }
    }
    );

    worksheet.getColumn(1).width = 10;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 20;
    worksheet.addRow([]);

    //Footer Row
    // let footerRow = worksheet.addRow(['Employee Sales Report Generated from example.com at ' + date]);
    let footerRow = worksheet.addRow([footer]);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFB050' }
    };

    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:E${footerRow.number}`);

    //Generate & Save Excel File
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, title + '.xlsx');
    })

  }

  exportExcelCardCount(excelData) {

    //Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers
    const data = excelData.data;
    const footer = excelData.footers;
    let FromDate = excelData.FromDates;
    let ToDate = excelData.UpToDates;

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Data');


    //Add Row and formatting
    worksheet.mergeCells('A1', 'AA2');
    let titleRow = worksheet.getCell('C1');
     titleRow.value = title
    titleRow.font = {
      name: 'Calibri',
      size: 16,
      underline: 'single',
      bold: true,
      color: { argb: '0085A3' }
    }
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' }

    // Date
    //worksheet.mergeCells('F1:G4');
    // let d = new Date();
    // let date = d.getDate() + '-' + d.getMonth() + '-' + d.getFullYear();
    // let dateCell = worksheet.getCell('F1');
    // dateCell.value = date;
    // dateCell.font = {
    //   name: 'Calibri',
    //   size: 12,
    //   bold: true
    // }
    // dateCell.alignment = { vertical: 'middle', horizontal: 'center' }
    FromDate = new Date(FromDate).getDate() + '-' + ((new Date(FromDate).getMonth())+1) + '-' + new Date(FromDate).getFullYear()  + ' ' + new Date(FromDate).getHours() + ':' + new Date(FromDate).getMinutes() + ':' + new Date(FromDate).getSeconds();
    ToDate = new Date(ToDate).getDate() + '-' + ((new Date(ToDate).getMonth())+1) + '-' + new Date(ToDate).getFullYear()  + ' ' + new Date(ToDate).getHours() + ':' + new Date(ToDate).getMinutes() + ':' + new Date(ToDate).getSeconds();


    let FromCellText = worksheet.getCell('B4');
    FromCellText.value = "From Date :"
    FromCellText.font ={bold:true}
    let UptoCellText = worksheet.getCell('B5');
    UptoCellText.value = "To Date :"
    UptoCellText.font ={bold:true}
    let FromCellTextDate = worksheet.getCell('C4');
    FromCellTextDate.value = FromDate;
    //FromCellText.font ={bold:true}
    let UptoCellTextDate = worksheet.getCell('C5');
    UptoCellTextDate.value = ToDate;
    //UptoCellText.font ={bold:true}
    //Add Image
    // let myLogoImage = workbook.addImage({
    //   base64: logoFile.logoBase64,
    //   extension: 'png',
    // });
    // worksheet.mergeCells('A1:B4');
    // worksheet.addImage(myLogoImage, 'A1:A4');

    //Blank Row
    worksheet.addRow([]);
    worksheet.addRow([]); 
    //Adding Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DDD9C4' },
        bgColor: { argb: '' } 
               
      }
      cell.font = {
        bold: true,
        color: { argb: '000000' },
        size: 11
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' }

    // Adding Data with Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
      row.eachCell((cell, number) => {
        // cell.fill = {
        //   type: 'pattern',
        //   pattern: 'solid',
        //   fgColor: { argb: 'DDD9C4' },
        //   bgColor: { argb: '' } 
                 
        // }
        // cell.font = {
        //   bold: true,
        //   color: { argb: '000000' },
        //   size: 11
        // }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      })
      row.alignment = { vertical: 'middle', horizontal: 'center' }

      let sales = row.getCell(2);
      //let color = 'FF99FF99';
      sales.alignment = { vertical: 'middle', horizontal: 'left' }
      // let cell3 = row.getCell(3);
      // cell3.value = Number(cell3.value);
      // let cell4 = row.getCell(4);
      // cell4.value = Number(cell4.value);
      // let cell5 = row.getCell(5);
      // cell5.value = Number(cell5.value);
      // if (+sales.value < 200000) {
      //   color = 'FF9999'
      // }
      //let sales = row.getCell(5);
      // let color = 'FF99FF99';
      // if (+sales.value < 200000) {
      //   color = 'FF9999'
      // }

      // sales.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color }
      // }
    }
    );

    worksheet.getColumn(1).width = 25;
    worksheet.getColumn(2).width = 20;
    // worksheet.getColumn(3).width = 20;
    // worksheet.getColumn(4).width = 20;
    // worksheet.getColumn(5).width = 20;
    worksheet.addRow([]);

    //Footer Row
    // let footerRow = worksheet.addRow(['Employee Sales Report Generated from example.com at ' + date]);
    let footerRow = worksheet.addRow([footer]);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFB050' }
    };

    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:AA${footerRow.number}`);

    //Generate & Save Excel File
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, title + '.xlsx');
    })

  }

  exportExcelCardSummary(excelData) {

    //Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers
    const data = excelData.data;
    const footer = excelData.footers;
    let FromDate = excelData.FromDates;
    let ToDate = excelData.UpToDates;

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Data');


    //Add Row and formatting
    worksheet.mergeCells('A1', 'C2');
    let titleRow = worksheet.getCell('A1');
     titleRow.value = title
    titleRow.font = {
      name: 'Calibri',
      size: 16,
      underline: 'single',
      bold: true,
      color: { argb: '0085A3' }
    }
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' }

    // Date
    //worksheet.mergeCells('F1:G4');
    // let d = new Date();
    // let date = d.getDate() + '-' + d.getMonth() + '-' + d.getFullYear();
    // let dateCell = worksheet.getCell('F1');
    // dateCell.value = date;
    // dateCell.font = {
    //   name: 'Calibri',
    //   size: 12,
    //   bold: true
    // }
    // dateCell.alignment = { vertical: 'middle', horizontal: 'center' }
    FromDate = new Date(FromDate).getDate() + '-' + ((new Date(FromDate).getMonth())+1) + '-' + new Date(FromDate).getFullYear()  + ' ' + new Date(FromDate).getHours() + ':' + new Date(FromDate).getMinutes() + ':' + new Date(FromDate).getSeconds();
    ToDate = new Date(ToDate).getDate() + '-' + ((new Date(ToDate).getMonth())+1) + '-' + new Date(ToDate).getFullYear()  + ' ' + new Date(ToDate).getHours() + ':' + new Date(ToDate).getMinutes() + ':' + new Date(ToDate).getSeconds();


    let FromCellText = worksheet.getCell('B4');
    FromCellText.value = "From Date :"
    FromCellText.font ={bold:true}
    let UptoCellText = worksheet.getCell('B5');
    UptoCellText.value = "To Date :"
    UptoCellText.font ={bold:true}
    let FromCellTextDate = worksheet.getCell('C4');
    FromCellTextDate.value = FromDate;
    //FromCellText.font ={bold:true}
    let UptoCellTextDate = worksheet.getCell('C5');
    UptoCellTextDate.value = ToDate;
    //UptoCellText.font ={bold:true}
    //Add Image
    // let myLogoImage = workbook.addImage({
    //   base64: logoFile.logoBase64,
    //   extension: 'png',
    // });
    // worksheet.mergeCells('A1:B4');
    // worksheet.addImage(myLogoImage, 'A1:A4');

    //Blank Row
    worksheet.addRow([]);
    worksheet.addRow([]); 
    //Adding Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DDD9C4' },
        bgColor: { argb: '' } 
               
      }
      cell.font = {
        bold: true,
        color: { argb: '000000' },
        size: 11
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' }

    // Adding Data with Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
      row.eachCell((cell, number) => {
        // cell.fill = {
        //   type: 'pattern',
        //   pattern: 'solid',
        //   fgColor: { argb: 'DDD9C4' },
        //   bgColor: { argb: '' } 
                 
        // }
        // cell.font = {
        //   bold: true,
        //   color: { argb: '000000' },
        //   size: 11
        // }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      })
      row.alignment = { vertical: 'middle', horizontal: 'center' }

      //let sales = row.getCell(2);
      //let color = 'FF99FF99';
      //sales.alignment = { vertical: 'middle', horizontal: 'left' }
      // let cell3 = row.getCell(3);
      // cell3.value = Number(cell3.value);
      // let cell4 = row.getCell(4);
      // cell4.value = Number(cell4.value);
      // let cell5 = row.getCell(5);
      // cell5.value = Number(cell5.value);
      // if (+sales.value < 200000) {
      //   color = 'FF9999'
      // }
      //let sales = row.getCell(5);
      // let color = 'FF99FF99';
      // if (+sales.value < 200000) {
      //   color = 'FF9999'
      // }

      // sales.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color }
      // }
    }
    );

    worksheet.getColumn(1).width = 30;
    worksheet.getColumn(2).width = 30;
    worksheet.getColumn(3).width = 30;
    // worksheet.getColumn(4).width = 20;
    // worksheet.getColumn(5).width = 20;
    worksheet.addRow([]);

    //Footer Row
    // let footerRow = worksheet.addRow(['Employee Sales Report Generated from example.com at ' + date]);
    let footerRow = worksheet.addRow([footer]);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFB050' }
    };

    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:C${footerRow.number}`);

    //Generate & Save Excel File
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, title + '.xlsx');
    })

  }
  exportExcelCardNoWise(excelData) {

    //Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers
    const data = excelData.data;
    const footer = excelData.footers;
    let FromDate = excelData.FromDates;
    let ToDate = excelData.UpToDates;

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Data');


    //Add Row and formatting
    worksheet.mergeCells('A1', 'C2');
    let titleRow = worksheet.getCell('A1');
     titleRow.value = title
    titleRow.font = {
      name: 'Calibri',
      size: 16,
      underline: 'single',
      bold: true,
      color: { argb: '0085A3' }
    }
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' }

    // Date
    //worksheet.mergeCells('F1:G4');
    // let d = new Date();
    // let date = d.getDate() + '-' + d.getMonth() + '-' + d.getFullYear();
    // let dateCell = worksheet.getCell('F1');
    // dateCell.value = date;
    // dateCell.font = {
    //   name: 'Calibri',
    //   size: 12,
    //   bold: true
    // }
    // dateCell.alignment = { vertical: 'middle', horizontal: 'center' }
    FromDate = new Date(FromDate).getDate() + '-' + ((new Date(FromDate).getMonth())+1) + '-' + new Date(FromDate).getFullYear()  + ' ' + new Date(FromDate).getHours() + ':' + new Date(FromDate).getMinutes() + ':' + new Date(FromDate).getSeconds();
    ToDate = new Date(ToDate).getDate() + '-' + ((new Date(ToDate).getMonth())+1) + '-' + new Date(ToDate).getFullYear()  + ' ' + new Date(ToDate).getHours() + ':' + new Date(ToDate).getMinutes() + ':' + new Date(ToDate).getSeconds();


    let FromCellText = worksheet.getCell('B4');
    FromCellText.value = "From Date :"
    FromCellText.font ={bold:true}
    let UptoCellText = worksheet.getCell('B5');
    UptoCellText.value = "To Date :"
    UptoCellText.font ={bold:true}
    let FromCellTextDate = worksheet.getCell('C4');
    FromCellTextDate.value = FromDate;
    //FromCellText.font ={bold:true}
    let UptoCellTextDate = worksheet.getCell('C5');
    UptoCellTextDate.value = ToDate;
    //UptoCellText.font ={bold:true}
    //Add Image
    // let myLogoImage = workbook.addImage({
    //   base64: logoFile.logoBase64,
    //   extension: 'png',
    // });
    // worksheet.mergeCells('A1:B4');
    // worksheet.addImage(myLogoImage, 'A1:A4');

    //Blank Row
    worksheet.addRow([]);
    worksheet.addRow([]); 
    //Adding Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DDD9C4' },
        bgColor: { argb: '' } 
               
      }
      cell.font = {
        bold: true,
        color: { argb: '000000' },
        size: 11
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' }

    // Adding Data with Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
      row.eachCell((cell, number) => {
        // cell.fill = {
        //   type: 'pattern',
        //   pattern: 'solid',
        //   fgColor: { argb: 'DDD9C4' },
        //   bgColor: { argb: '' } 
                 
        // }
        // cell.font = {
        //   bold: true,
        //   color: { argb: '000000' },
        //   size: 11
        // }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      })
      row.alignment = { vertical: 'middle', horizontal: 'center' }

      //let sales = row.getCell(2);
      //let color = 'FF99FF99';
      // sales.alignment = { vertical: 'middle', horizontal: 'left' }
      // let cell3 = row.getCell(3);
      // cell3.value = Number(cell3.value);
      // let cell4 = row.getCell(4);
      // cell4.value = Number(cell4.value);
      // let cell5 = row.getCell(5);
      // cell5.value = Number(cell5.value);
      // if (+sales.value < 200000) {
      //   color = 'FF9999'
      // }
      //let sales = row.getCell(5);
      // let color = 'FF99FF99';
      // if (+sales.value < 200000) {
      //   color = 'FF9999'
      // }

      // sales.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color }
      // }
    }
    );

    worksheet.getColumn(1).width = 30;
    worksheet.getColumn(2).width = 30;
    worksheet.getColumn(3).width = 30;
    // worksheet.getColumn(4).width = 20;
    // worksheet.getColumn(5).width = 20;
    worksheet.addRow([]);

    //Footer Row
    // let footerRow = worksheet.addRow(['Employee Sales Report Generated from example.com at ' + date]);
    let footerRow = worksheet.addRow([footer]);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFB050' }
    };

    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:C${footerRow.number}`);

    //Generate & Save Excel File
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, title + '.xlsx');
    })

  }

  exportExcelCardDetails(excelData) {

    //Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers
    const data = excelData.data;
    const footer = excelData.footers;
    let FromDate = excelData.FromDates;
    let ToDate = excelData.UpToDates;

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Data');


    //Add Row and formatting
    worksheet.mergeCells('A1', 'D2');
    let titleRow = worksheet.getCell('A1');
     titleRow.value = title
    titleRow.font = {
      name: 'Calibri',
      size: 16,
      underline: 'single',
      bold: true,
      color: { argb: '0085A3' }
    }
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' }

    // Date
    //worksheet.mergeCells('F1:G4');
    // let d = new Date();
    // let date = d.getDate() + '-' + d.getMonth() + '-' + d.getFullYear();
    // let dateCell = worksheet.getCell('F1');
    // dateCell.value = date;
    // dateCell.font = {
    //   name: 'Calibri',
    //   size: 12,
    //   bold: true
    // }
    // dateCell.alignment = { vertical: 'middle', horizontal: 'center' }
    FromDate = new Date(FromDate).getDate() + '-' + ((new Date(FromDate).getMonth())+1) + '-' + new Date(FromDate).getFullYear()  + ' ' + new Date(FromDate).getHours() + ':' + new Date(FromDate).getMinutes() + ':' + new Date(FromDate).getSeconds();
    ToDate = new Date(ToDate).getDate() + '-' + ((new Date(ToDate).getMonth())+1) + '-' + new Date(ToDate).getFullYear()  + ' ' + new Date(ToDate).getHours() + ':' + new Date(ToDate).getMinutes() + ':' + new Date(ToDate).getSeconds();


    let FromCellText = worksheet.getCell('B4');
    FromCellText.value = "From Date :"
    FromCellText.font ={bold:true}
    let UptoCellText = worksheet.getCell('B5');
    UptoCellText.value = "To Date :"
    UptoCellText.font ={bold:true}
    let FromCellTextDate = worksheet.getCell('C4');
    FromCellTextDate.value = FromDate;
    //FromCellText.font ={bold:true}
    let UptoCellTextDate = worksheet.getCell('C5');
    UptoCellTextDate.value = ToDate;
    //UptoCellText.font ={bold:true}
    //Add Image
    // let myLogoImage = workbook.addImage({
    //   base64: logoFile.logoBase64,
    //   extension: 'png',
    // });
    // worksheet.mergeCells('A1:B4');
    // worksheet.addImage(myLogoImage, 'A1:A4');

    //Blank Row
    worksheet.addRow([]);
    worksheet.addRow([]); 
    //Adding Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DDD9C4' },
        bgColor: { argb: '' } 
               
      }
      cell.font = {
        bold: true,
        color: { argb: '000000' },
        size: 11
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' }

    // Adding Data with Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
      row.eachCell((cell, number) => {
        // cell.fill = {
        //   type: 'pattern',
        //   pattern: 'solid',
        //   fgColor: { argb: 'DDD9C4' },
        //   bgColor: { argb: '' } 
                 
        // }
        // cell.font = {
        //   bold: true,
        //   color: { argb: '000000' },
        //   size: 11
        // }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      })
      row.alignment = { vertical: 'middle', horizontal: 'center' }

      //let sales = row.getCell(2);
      //let color = 'FF99FF99';
      // sales.alignment = { vertical: 'middle', horizontal: 'left' }
      // let cell3 = row.getCell(3);
      // cell3.value = Number(cell3.value);
      // let cell4 = row.getCell(4);
      // cell4.value = Number(cell4.value);
      // let cell5 = row.getCell(5);
      // cell5.value = Number(cell5.value);
      // if (+sales.value < 200000) {
      //   color = 'FF9999'
      // }
      //let sales = row.getCell(5);
      // let color = 'FF99FF99';
      // if (+sales.value < 200000) {
      //   color = 'FF9999'
      // }

      // sales.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color }
      // }
    }
    );

    worksheet.getColumn(1).width = 30;
    worksheet.getColumn(2).width = 30;
    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 30;
    // worksheet.getColumn(5).width = 20;
    worksheet.addRow([]);

    //Footer Row
    // let footerRow = worksheet.addRow(['Employee Sales Report Generated from example.com at ' + date]);
    let footerRow = worksheet.addRow([footer]);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFB050' }
    };

    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:D${footerRow.number}`);

    //Generate & Save Excel File
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, title + '.xlsx');
    })

  }

  exportExcelCustomerLogs(excelData) {

    //Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers
    const data = excelData.data;
    const footer = excelData.footers;
    let FromDate = excelData.FromDates;
    let ToDate = excelData.UpToDates;

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Data');


    //Add Row and formatting
    worksheet.mergeCells('A1', 'E2');
    let titleRow = worksheet.getCell('A1');
     titleRow.value = title
    titleRow.font = {
      name: 'Calibri',
      size: 16,
      underline: 'single',
      bold: true,
      color: { argb: '0085A3' }
    }
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' }

    // Date
    //worksheet.mergeCells('F1:G4');
    // let d = new Date();
    // let date = d.getDate() + '-' + d.getMonth() + '-' + d.getFullYear();
    // let dateCell = worksheet.getCell('F1');
    // dateCell.value = date;
    // dateCell.font = {
    //   name: 'Calibri',
    //   size: 12,
    //   bold: true
    // }
    // dateCell.alignment = { vertical: 'middle', horizontal: 'center' }
    FromDate = new Date(FromDate).getDate() + '-' + ((new Date(FromDate).getMonth())+1) + '-' + new Date(FromDate).getFullYear()  + ' ' + new Date(FromDate).getHours() + ':' + new Date(FromDate).getMinutes() + ':' + new Date(FromDate).getSeconds();
    ToDate = new Date(ToDate).getDate() + '-' + ((new Date(ToDate).getMonth())+1) + '-' + new Date(ToDate).getFullYear()  + ' ' + new Date(ToDate).getHours() + ':' + new Date(ToDate).getMinutes() + ':' + new Date(ToDate).getSeconds();


    let FromCellText = worksheet.getCell('B4');
    FromCellText.value = "From Date :"
    FromCellText.font ={bold:true}
    let UptoCellText = worksheet.getCell('B5');
    UptoCellText.value = "To Date :"
    UptoCellText.font ={bold:true}
    let FromCellTextDate = worksheet.getCell('C4');
    FromCellTextDate.value = FromDate;
    //FromCellText.font ={bold:true}
    let UptoCellTextDate = worksheet.getCell('C5');
    UptoCellTextDate.value = ToDate;
    //UptoCellText.font ={bold:true}
    //Add Image
    // let myLogoImage = workbook.addImage({
    //   base64: logoFile.logoBase64,
    //   extension: 'png',
    // });
    // worksheet.mergeCells('A1:B4');
    // worksheet.addImage(myLogoImage, 'A1:A4');

    //Blank Row
    worksheet.addRow([]);
    worksheet.addRow([]); 
    //Adding Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DDD9C4' },
        bgColor: { argb: '' } 
               
      }
      cell.font = {
        bold: true,
        color: { argb: '000000' },
        size: 11
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' }

    // Adding Data with Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
      row.eachCell((cell, number) => {
        // cell.fill = {
        //   type: 'pattern',
        //   pattern: 'solid',
        //   fgColor: { argb: 'DDD9C4' },
        //   bgColor: { argb: '' } 
                 
        // }
        // cell.font = {
        //   bold: true,
        //   color: { argb: '000000' },
        //   size: 11
        // }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      })
      row.alignment = { vertical: 'middle', horizontal: 'center' }

      //let sales = row.getCell(2);
      //let color = 'FF99FF99';
      // sales.alignment = { vertical: 'middle', horizontal: 'left' }
      // let cell3 = row.getCell(3);
      // cell3.value = Number(cell3.value);
      // let cell4 = row.getCell(4);
      // cell4.value = Number(cell4.value);
      // let cell5 = row.getCell(5);
      // cell5.value = Number(cell5.value);
      // if (+sales.value < 200000) {
      //   color = 'FF9999'
      // }
      //let sales = row.getCell(5);
      // let color = 'FF99FF99';
      // if (+sales.value < 200000) {
      //   color = 'FF9999'
      // }

      // sales.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color }
      // }
    }
    );
    for (var i = 1; i < 47; i++) {
      worksheet.getColumn(i).width = 30;
    }
    // worksheet.getColumn(1).width = 30;
    // worksheet.getColumn(2).width = 30;
    // worksheet.getColumn(3).width = 30;
    // worksheet.getColumn(4).width = 30;
    // worksheet.getColumn(5).width = 20;
    worksheet.addRow([]);

    //Footer Row
    // let footerRow = worksheet.addRow(['Employee Sales Report Generated from example.com at ' + date]);
    let footerRow = worksheet.addRow([footer]);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFB050' }
    };

    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:AT${footerRow.number}`);

    //Generate & Save Excel File
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, title + '.xlsx');
    })

  }

  //   download(url: string): Observable<Blob> {
//     return this.http.get(url, { 
//       responseType: 'blob' 
//     })
//  }


}
